import React, { useState, useRef } from "react";

export const Team = ({ data }) => {
  const [activeId, setActiveId] = useState(null);
  const [caretLeft, setCaretLeft] = useState(0);

  // Reference to the row containing the photos
  const rowRef = useRef(null);

  const handleSelect = (id, event) => {
    // Clicking the same card clears the panel
    if (activeId === id) {
      setActiveId(null);
      return;
    }

    // Get bounding boxes
    const cardRect = event.currentTarget.getBoundingClientRect();
    const containerRect = rowRef.current.getBoundingClientRect();

    // Convert viewport coordinates → container-relative coordinates
    const centerX =
      cardRect.left +
      cardRect.width / 2 -
      containerRect.left;

    setCaretLeft(centerX);
    setActiveId(id);
  };

  return (
    <section id="team" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Meet the Team</h2>
        </div>

        {/* Row of photos */}
        <div className="team-wrapper" ref={rowRef}>
          {data
            ? data.map((person, i) => (
                <TeamCard
                  key={`${person.name}-${i}`}
                  person={person}
                  onSelect={handleSelect}
                />
              ))
            : "loading"}
        </div>

        {/* Shared bio panel */}
        <div className="team-bio-panel">
          {activeId && (
            <>
              <div
                className="team-caret"
                style={{ left: caretLeft }}
              />
              <div className="team-bio-text">
                <p>{data.find((p) => p.name === activeId).bio}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

const TeamCard = ({ person, onSelect }) => {
  return (
    <div
      className="team-card"
      onClick={(e) => onSelect(person.name, e)}
    >
      <div className="team-photo">
        <img src={person.img} alt={person.name} className="team-img" />
        <div className="caption">
          <h4>{person.name}</h4>
          <p>{person.job}</p>
        </div>
      </div>
    </div>
  );
};
